import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setTimeout(() => {
        setEmail('');
        setIsSubmitted(false);
      }, 3000);
    }
  };

  return (
    <section className="py-16 bg-primary text-primary-foreground">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-16 h-16 rounded-full bg-primary-foreground/10 flex items-center justify-center mx-auto mb-6">
            <Icon name="Mail" size={32} color="var(--color-primary-foreground)" />
          </div>

          <h2 className="font-serif text-4xl font-bold mb-4">
            Join Our Italian Famiglia
          </h2>
          <p className="text-lg opacity-90 mb-8 max-w-2xl mx-auto">
            Subscribe to receive daily specials, seasonal treats, exclusive offers, and authentic Italian baking tips delivered fresh to your inbox every week.
          </p>

          {isSubmitted ? (
            <div className="max-w-md mx-auto p-6 rounded-xl bg-success/20 border border-success/30">
              <div className="flex items-center justify-center gap-3 text-success-foreground">
                <Icon name="CheckCircle" size={24} />
                <span className="font-medium">Thank you for subscribing!</span>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="max-w-md mx-auto">
              <div className="flex flex-col sm:flex-row gap-3">
                <div className="flex-1">
                  <Input
                    type="email"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) => setEmail(e?.target?.value)}
                    required
                    className="bg-primary-foreground/10 border-primary-foreground/20 text-primary-foreground placeholder:text-primary-foreground/60"
                  />
                </div>
                <Button
                  type="submit"
                  variant="secondary"
                  iconName="Send"
                  iconPosition="left"
                >
                  Subscribe
                </Button>
              </div>
              <p className="text-sm opacity-75 mt-4">
                We respect your privacy. Unsubscribe anytime.
              </p>
            </form>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12 pt-12 border-t border-primary-foreground/20">
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">471+</div>
              <div className="text-sm opacity-75">Happy Customers</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">38+</div>
              <div className="text-sm opacity-75">Years of Tradition</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">4.7★</div>
              <div className="text-sm opacity-75">Average Rating</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;